package nl.volleyplanner.web.base.text

import nl.volleyplanner.sportconfig.NevoboAgeGroup
import nl.volleyplanner.sportconfig.NevoboTeamName
import nl.volleyplanner.types.Gender

fun NevoboTeamName.shortDisplayLabel() : String {
    val start = when {
        gender == Gender.Men && ageGroup == NevoboAgeGroup.Senior -> "HS "
        gender == Gender.Women && ageGroup == NevoboAgeGroup.Senior -> "DS "
        gender == Gender.Men && ageGroup != NevoboAgeGroup.Senior -> "J${ageGroup.identifier} "
        gender == Gender.Women && ageGroup != NevoboAgeGroup.Senior -> "M${ageGroup.identifier} "
        gender == Gender.Mixed && ageGroup != NevoboAgeGroup.CMV -> "X"
        ageGroup == NevoboAgeGroup.CMV -> "N$cmvLevel "
        else -> "U"
    }
    return start + teamNumber
}